"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParsedParameterSchema = exports.VariancePropertiesSchema = exports.StoredValueVarianceSchema = exports.ValueVarianceSchema = void 0;
exports.isValueVariance = isValueVariance;
const zod_1 = require("zod");
const SIUnitDeclaration_1 = require("./SIUnitDeclaration");
function isValueVariance(v) {
    if (typeof v !== 'object' || v === null || !('value' in v)) {
        return false;
    }
    const keys = Object.keys(v);
    return keys.every((k) => k === 'value' || k === 'variance');
}
exports.ValueVarianceSchema = zod_1.z.object({
    value: zod_1.z.number().optional(),
    variance: zod_1.z.string().optional(),
});
exports.StoredValueVarianceSchema = zod_1.z.object({
    value: zod_1.z.union([zod_1.z.number(), zod_1.z.string()]).optional(),
    variance: zod_1.z.string().optional(),
});
exports.VariancePropertiesSchema = zod_1.z.object({
    value: zod_1.z.number(),
    units: SIUnitDeclaration_1.SIUnitDeclarationSchema,
    singleSided: zod_1.z.boolean(),
});
exports.ParsedParameterSchema = zod_1.z.record(zod_1.z.string(), exports.ValueVarianceSchema);
//# sourceMappingURL=VarianceTypes.js.map